const CallToAction = (): JSX.Element => {return (
  <section className="brand-strip">
    <h2 className="brand-heading">
      Ready to focus on work and learning with <span className="brand-accent">WerxPace</span>?
    </h2>
    <a className="btn pill" href="#downloads-section">Download here</a>
  </section>
)};

export default CallToAction;
